import { FunctionComponent, useEffect, useState } from "react"
import { MapContainer, TileLayer, Marker, Popup, Polygon, useMapEvents } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.webpack.css' // Re-uses images from ~leaflet package
import 'leaflet-defaulticon-compatibility'
import { LatLng } from "leaflet"
import step17 from '../../assets/img/step17.svg'
import ProgressBar from "../ProgressBar/ProgressBar"

import AnteriorSiguienteButtons from "../AnteriorSiguienteButtons/AnteriorSiguienteButtons"
import HeaderImage from '../GenericStep/Header'
import nData from './neighbourhood.json'
import store from '../../utils/store'
import { markerData } from "../../utils/interfaces"

interface ContainerProps {
}

const Step17: FunctionComponent<ContainerProps> = (props) => {
    const selectedBarrio = store.state.barrio ?? null

    const data = (nData.filter( (d) => d.name === selectedBarrio ))[0]

    const options = {
        fillColor: 'none',
        color: "#c71212",
        weight: 5,
        opacity: 0.65,
        fillOpacity: 0.00
    }

    const aspectList = store.getAnswersMap()

    const [ selectedIndex, setSelectedIndex ] = useState<number>( -1 )

    const [ markers, setMarkers ] = useState<markerData[]>( [] )
    const [ layoutMarkers, setLayoutMarkers ] = useState<any>( )

    useEffect( () => {
        setLayoutMarkers(
            markers?.map( (m, idx) =>
                <Marker key={`marker-${idx}`} position={m.latlng}>
                    <Popup>
                        {m.name}
                    </Popup>
                </Marker>
            )
        )
        store.setMarkers(markers)
    }, [ markers, ] )

    const AddMarkerComponent = () => {
        useMapEvents(
            {
                click ( e ) {
                    if ( selectedIndex > -1 ) {
                        if ( insidePolygon( e.latlng ) ) {
                            // setMarkers( [...markers, e.latlng] )
                            const markersLocal = [...markers]
                            markersLocal.push ( {
                                latlng: e.latlng,
                                name: aspectList[ selectedIndex ]
                            })
                            setMarkers( markersLocal )
                        } else {
                            alert( "Debe indicar un punto dentro del barrio demarcado" )
                        }
                    } else {
                        alert( "Primero debe seleccionar un aspecto" )
                    }
                },
            }
        )
        return layoutMarkers
    }

    const insidePolygon = ( latlng: LatLng ) => { // https://stackoverflow.com/a/31813714
        const polyPoints = data.polygon[0]
        const x = latlng.lat
        const y = latlng.lng

        let inside = false;
        for (let i = 0, j = polyPoints.length - 1; i < polyPoints.length; j = i++) {
            let xi = polyPoints[i].lat, yi = polyPoints[i].lng;
            let xj = polyPoints[j].lat, yj = polyPoints[j].lng;

            let intersect = ((yi > y) !== (yj > y))
                && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
            if (intersect) inside = !inside;
        }

        return inside;
    }

    // const position = { lat: -31.63492, lng: -60.70524 }
    return (
        <div className="body container-fluid">
            <HeaderImage image={step17}></HeaderImage>

            <div className="row justify-content-center">
                <div className="col-md-6 bottommargin">
                    <span style={{ verticalAlign: 'inherit' }}>
                        <span className="p"> <strong>Seleccione de a uno los aspectos y márquelos en el mapa</strong></span>
                    </span>
                    <div className="dropdown">
                        <button
                            className="btn btn-primary dropdown-toggle"
                            type="button" id="dropdownMenuAspect"
                            data-toggle="dropdown"
                        >
                            { selectedIndex > -1 ? aspectList[selectedIndex] : 'Por favor seleccione una opción'}
                        </button>
                        <div className="dropdown-menu" aria-labelledby="dropdownMenuAspect">
                            { aspectList.map( ( a: string, index: number ) =>
                                <button className="dropdown-item" key={`aspect-${index}`} onClick={ () => setSelectedIndex( index ) }>{a}</button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className="row justify-content-center">
                <div className="col-md-8">
                    { data ?
                    <MapContainer
                        center={data.center}
                        zoom={15}
                        minZoom={15}
                        maxZoom={18}
                        scrollWheelZoom={false}
                        style={{ width: '100%', height: '70vh' }}
                    >
                        <TileLayer
                            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        <Polygon pathOptions={options} positions={data.polygon} />
                        <AddMarkerComponent />
                    </MapContainer>
                    : 'No se registran respuestas para marcar en el mapa' }
                </div>
            </div>
            <AnteriorSiguienteButtons linkAnterior={"/step16"} linkSiguiente="/step18" linkOmitir="/step18"></AnteriorSiguienteButtons>
            <ProgressBar progress={85}></ProgressBar>
        </div>
    )
}
export default Step17
